var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReturns(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#4b4495;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Your_returns-2",
    "data-name": "Your returns-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25585-2",
    "data-name": "Path 25585-2",
    className: "cls-1",
    d: "M0,0H24V24H0Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_195-2",
    "data-name": "Group 195-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18-2",
    "data-name": "Path 18-2",
    className: "cls-2",
    d: "M21.56,6.52,19.2,3.08A2.7,2.7,0,0,0,17,2H7A2.51,2.51,0,0,0,4.84,3.12L2.48,6.56A2.27,2.27,0,0,0,2,8V19.44A2.58,2.58,0,0,0,4.56,22H19.4A2.55,2.55,0,0,0,22,19.46V8A2.44,2.44,0,0,0,21.56,6.52ZM17,4a.55.55,0,0,1,.48.24L19,6.4H13V4ZM6.48,4.24A.55.55,0,0,1,7,4h4V6.4H5ZM20,19.44a.55.55,0,0,1-.53.56H4.56A.55.55,0,0,1,4,19.47V8.92a.52.52,0,0,1,.52-.52h15a.52.52,0,0,1,.52.52V19.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29340",
    "data-name": "Path 29340",
    className: "cls-2",
    d: "M12.11,11.55A6,6,0,0,0,8.18,13l-2-2V16.1h5.11L9.2,14a4.51,4.51,0,0,1,6.38.54,4.6,4.6,0,0,1,.85,1.51l1.34-.44A6,6,0,0,0,12.11,11.55Z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturns);
export default __webpack_public_path__ + "static/media/Returns.a1aa40e54bf0ae14ad4529f37be60e5c.svg";
export { ForwardRef as ReactComponent };